import { render, staticRenderFns } from "./BlankContainer.vue?vue&type=template&id=41915412&"
import script from "./BlankContainer.vue?vue&type=script&lang=js&"
export * from "./BlankContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BlankContainer.vue"
export default component.exports